export const CARNUMFLAG = "CARNUMFLAG";
export const ADDCARNUMBER = "ADDCARNUMBER";
export const ADDCARDETAILS = "ADDCARDETAILS";
export const ALLCARDETAILS = "ALLCARDETAILS";
export const CAR_INS_PRODUCT = "CAR_INS_PRODUCT";
export const PREV_INS_LIST = "PREV_INS_LIST";
export const QUICKQUOTES = "QUICKQUOTES";
export const QUICKQUOTE_POST_CAR = "QUICKQUOTE_POST_CAR";
export const QUICKQUOE_VALUE_CAR = "QUICKQUOE_VALUE_CAR";
export const PREV_POLICY_DETAIL_CAR = "PREV_POLICY_DETAIL_CAR";
export const SUMINSURANCE_AMOUNT = "SUMINSURANCE_AMOUNT";
export const ERROR_QUOTES_CAR = "ERROR_QUOTES_CAR";
export const BREAKIN_POLICY = "BREAKIN_POLICY";
export const CREATE_CRPROPOSAL = "CREATE_CRPROPOSAL";
export const PAYMENT_CRREQUEST = "PAYMENT_CRREQUEST";
export const KYC_CRSTATUS = "KYC_CRSTATUS";
export const TRANS_ID_CAR = "TRANS_ID_CAR";
export const POLICY_CRPDF = "POLICY_CRPDF";
export const RESET_CAR = "RESET_CAR";
